<template lang="html">
  <div>
    <div class="loader-wrap" v-if="!loaded">
      <div class="loader-content">
        <div class="loader">
          <div class="loader__item"></div>
        </div>
      </div>
    </div>

    <div class="content" v-else>
      <h1>Detail zákazníka</h1>

      <v-layout>
        <table class="info-table">
          <tr v-if="data.deleted_at">
            <td class="info-table__title"></td>
            <td class="info-table__value">
              <div class="status-wrap">
                <span class="status status--table status--error">Smazán</span>
              </div>
            </td>
          </tr>
          <tr>
            <td class="info-table__title">
              ID:
            </td>
            <td class="info-table__value">
              <v-text-field
                disabled
                class="input--small"
                outlined
                v-model="data.id"
              >
              </v-text-field>
            </td>
          </tr>
          <tr>
            <td class="info-table__title">
              Jméno:
            </td>
            <td class="info-table__value">
              <v-text-field
                class="input--small"
                outlined
                v-model="data.forename"
              >
              </v-text-field>
            </td>
          </tr>
          <tr>
            <td class="info-table__title">
              Příjmení:
            </td>
            <td class="info-table__value">
              <v-text-field
                class="input--small"
                outlined
                v-model="data.surname"
              >
              </v-text-field>
            </td>
          </tr>
          <tr>
            <td class="info-table__title">
              E-mail:
            </td>
            <td class="info-table__value">
              <v-text-field
                disabled
                class="input--small"
                outlined
                v-model="data.email"
              >
              </v-text-field>
            </td>
          </tr>
          <tr>
            <td class="info-table__title">
              Datum narození:<br />
              <span>(DD-MM-YYYY)</span>
            </td>
            <td class="info-table__value">
              <v-text-field
                class="input--small"
                outlined
                v-model="data.date_of_birth"
              >
              </v-text-field>
            </td>
          </tr>
          <tr>
            <td class="info-table__title">
              Ulice:
            </td>
            <td class="info-table__value">
              <v-text-field class="input--small" outlined v-model="data.street">
              </v-text-field>
            </td>
          </tr>

          <tr>
            <td class="info-table__title">
              Č.p.:
            </td>
            <td class="info-table__value">
              <v-text-field class="input--small" outlined v-model="data.no">
              </v-text-field>
            </td>
          </tr>

          <tr>
            <td class="info-table__title">
              Město:
            </td>
            <td class="info-table__value">
              <v-text-field class="input--small" outlined v-model="data.city">
              </v-text-field>
            </td>
          </tr>

          <tr>
            <td class="info-table__title">
              PSČ:
            </td>
            <td class="info-table__value">
              <v-text-field class="input--small" outlined v-model="data.zip">
              </v-text-field>
            </td>
          </tr>

          <tr>
            <td class="info-table__title">
              Stát:
            </td>
            <td class="info-table__value">
              <v-select class="input--small" outlined v-model="data.country" :items="[{text: 'Česká republika', value: 'CZ'}, {text: 'Slovenská republika', value: 'SK'}]">
              </v-select>
            </td>
          </tr>

          <tr>
            <td class="info-table__title">
              Telefon:
            </td>
            <td class="info-table__value">
              <v-text-field class="input--small" outlined v-model="data.tel">
              </v-text-field>
            </td>
          </tr>

          <tr>
            <td class="info-table__title">
              IČ:
            </td>
            <td class="info-table__value">
              <v-text-field class="input--small" outlined v-model="data.ico">
              </v-text-field>
            </td>
          </tr>

          <tr>
            <td class="info-table__title">
              DIČ:
            </td>
            <td class="info-table__value">
              <v-text-field class="input--small" outlined v-model="data.dic">
              </v-text-field>
            </td>
          </tr>

          <tr>
            <td class="info-table__title">
              Společnost:
            </td>
            <td class="info-table__value">
              <v-text-field
                class="input--small"
                outlined
                v-model="data.company"
              >
              </v-text-field>
            </td>
          </tr>
        </table>
      </v-layout>
      <v-layout>
        <div class="controls-table">
          <v-btn
            color="primary"
            type="submit"
            class="button--control"
            @click="editUser()"
          >
            Uložit
          </v-btn>
          <v-btn
            color="secondary"
            class="button--control"
            @click="openDialogEmail()"
          >
            Změnit email
          </v-btn>

          <v-btn
            v-if="!data.deleted_at"
            color="error"
            class="button--control"
            @click="openDialogDelete()"
          >
            Smazat
          </v-btn>
        </div>
      </v-layout>
      <div style="padding-top: 10px">
        <v-btn
          color="secondary"
          class="button--control"
          @click="openDialogForgot()"
        >
          Odeslat email pro změnu hesla
        </v-btn>
      </div>

      <div class="mt-4">
        <v-btn color="secondary" @click="openMergeDialog"
          >Migrovat objednávky</v-btn
        >
      </div>

      <div class="loader-wrap" v-if="loading">
        <div class="loader-content">
          <div class="loader">
            <div class="loader__item"></div>
          </div>
        </div>
      </div>

      <v-row justify="center">
        <v-dialog v-model="mergeAccountDialog" persistent max-width="680">
          <v-card>
            <v-card-title class="text-h5 mb-8">
              <span style="word-break:break-word;">
                Vyhledejte uživatele od kterého se budou migrovat objednávky
              </span>
            </v-card-title>
            <v-card-text>
              <table style="width:100%">
                <tr>
                  <td>
                    <v-text-field
                      v-model="searchAccount"
                      outlined
                      label="Email uživatele"
                    />
                  </td>
                  <td>
                    <v-btn
                      color="primary"
                      :loading="loadingAccounts"
                      :disabled="
                        !searchAccount || !searchAccount.length ? true : false
                      "
                      @click="handleSearchAccount"
                      >Vyhledat</v-btn
                    >
                  </td>
                </tr>
              </table>

              <div
                class="mt-8 text-left found-accounts-view"
                v-if="selectedAccount"
              >
                <div class="mb-2">
                  <strong>ID: {{ selectedAccount.id }}</strong>
                  {{ selectedAccount.email }} - {{ selectedAccount.forename }}
                  {{ selectedAccount.surname }}
                  <button
                    class="d-inline button-small--primary"
                    type="button"
                    @click="selectedAccount = null"
                  >
                    <strong>Zrušit výběr</strong>
                  </button>
                </div>
              </div>

              <div
                class="mt-8 text-left found-accounts-view"
                v-if="foundAccounts.length"
              >
                <div v-for="account in foundAccounts" class="mb-2">
                  <strong>ID:{{ account.id }}</strong> {{ account.email }} -
                  {{ account.forename }}
                  {{ account.surname }}
                  <button
                    class="d-inline button-small--primary"
                    type="button"
                    @click="handleSelectAccount(account)"
                  >
                    <strong>Vybrat</strong>
                  </button>
                </div>
              </div>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                text
                @click="
                  (mergeAccountDialog = false),
                    (selectedAccount = null),
                    (foundAccounts = []),
                    (confirmMerging = false)
                "
              >
                zavřít
              </v-btn>
              <v-btn
                color="primary darken-1"
                text
                :disabled="selectedAccount ? false : true"
                @click="confirmMerging = true"
              >
                Převést
              </v-btn>
              <v-btn
                v-if="confirmMerging"
                :loading="merging"
                @click="mergeAccount"
                color="primary"
                >potvrdit</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>

      <v-snackbar v-model="snackbar">
        {{ snackText }}

        <template v-slot:action="{ attrs }">
          <v-btn
            :color="snackColor"
            text
            v-bind="attrs"
            @click="snackbar = false"
          >
            Zavřít
          </v-btn>
        </template>
      </v-snackbar>

      <h2>Statistiky</h2>
      <v-layout>
        <table class="info-table">
          <tr v-if="data.deleted_at">
            <td class="info-table__title">
              Smazán:
            </td>
            <td class="info-table__value">
              <v-text-field
                disabled
                class="input--small"
                outlined
                :value="formatCreatedAt(data.deleted_at)"
              >
              </v-text-field>
            </td>
          </tr>
          <tr>
            <td class="info-table__title">
              Registrován:
            </td>
            <td class="info-table__value">
              <v-text-field
                disabled
                class="input--small"
                outlined
                :value="formatCreatedAt(data.created_at)"
              >
              </v-text-field>
            </td>
          </tr>
          <tr>
            <td class="info-table__title">
              Naposledy přihlášen:
            </td>
            <td class="info-table__value">
              <v-text-field
                disabled
                class="input--small"
                outlined
                :value="formatLastLog(data.last_log)"
              >
              </v-text-field>
            </td>
          </tr>
          <tr>
            <td class="info-table__title">
              Počet objednávek:
            </td>
            <td class="info-table__value">
              <v-text-field
                disabled
                class="input--small"
                outlined
                v-model="itemsOrders.length"
              >
              </v-text-field>
            </td>
          </tr>
          <tr>
            <td class="info-table__title">
              Počet zaplacených objednávek:
            </td>
            <td class="info-table__value">
              <v-text-field
                disabled
                class="input--small"
                outlined
                v-model="
                  itemsOrders.filter((item) => item.status == 'paid').length
                "
              >
              </v-text-field>
            </td>
          </tr>
          <tr>
            <td class="info-table__title">
              Hodnota zaplacených objednávek:<br />
              <span>(Kč)</span>
            </td>
            <td class="info-table__value">
              <v-text-field
                disabled
                class="input--small"
                outlined
                v-model="data.orders_price"
              >
              </v-text-field>
            </td>
          </tr>
          <tr>
            <td class="info-table__title">
              Hodnota zaplacených objednávek bez DPH:<br />
              <span>(Kč)</span>
            </td>
            <td class="info-table__value">
              <v-text-field
                disabled
                class="input--small"
                outlined
                v-model="data.orders_price_no_dph"
              >
              </v-text-field>
            </td>
          </tr>
          <tr>
            <td class="info-table__title">
              Počet audioknih:
            </td>
            <td class="info-table__value">
              <v-text-field
                disabled
                class="input--small"
                outlined
                v-model="itemsAudiobooks.length"
              >
              </v-text-field>
            </td>
          </tr>
        </table>
      </v-layout>
      <h2
        v-if="
          itemsOrders.length > 0 ||
            itemsAudiobooks.length > 0 ||
            itemsVouchers.length > 0
        "
      >
        Další informace
      </h2>
      <div class="order-items-tab" v-if="itemsOrders.length > 0">
        <h3>
          Seznam Objednávek <span>({{ itemsOrders.length }})</span>
        </h3>
        <v-text-field
          class="input--search control"
          placeholder="Vyhledat"
          outlined
          v-model="searchOrders"
        ></v-text-field>
        <v-data-table
          locale="cs"
          :headers="headersOrders"
          :items="itemsOrders"
          :search="searchOrders"
          :loading="false"
          item-key="name"
          :items-per-page="10"
          :mobile-breakpoint="0"
          class="elevation-1 full-width frankjoy-table"
        >
          <template slot="body" slot-scope="props">
            <tbody>
              <tr v-for="item in props.items" :key="item.id">
                <router-link
                  :to="{ name: 'OrdersDetail', params: { id: item.id } }"
                >
                  <td class="">{{ item.id }}</td>
                  <td class="bolder small">
                    {{ item.number
                    }}<span v-if="item.ios_receipt" class="apple-order"></span>
                  </td>

                  <td class="small">{{ formatCreatedAt(item.created_at) }}</td>
                  <td class="bold">
                    <span
                      v-bind:class="[
                        { 'normal small': !item.dph },
                        { 'actual-price': item.dph },
                      ]"
                    >
                      <span v-if="item.price"> {{ item.price }} Kč </span>
                      <span v-else>
                        0 Kč
                      </span>
                    </span>
                    <br />
                    <span
                      v-bind:class="[
                        { 'normal small': item.dph },
                        { 'actual-price': !item.dph },
                      ]"
                      ><span class="small">Bez DPH</span>
                      {{ item.price_no_dph }} Kč</span
                    >
                  </td>
                  <td class="small bold">
                    <span v-if="item.status === 'created'" class="status">{{
                      item.status_name
                    }}</span>
                    <span
                      v-else-if="item.status === 'canceled'"
                      class="status status--error"
                      >{{ item.status_name }}</span
                    >
                    <span
                      v-else-if="item.status === 'storned'"
                      class="status status--error"
                      >{{ item.status_name }}</span
                    >
                    <span
                      v-else-if="item.status === 'paid'"
                      class="status status--success"
                      >{{ item.status_name }}</span
                    >
                    <span
                      v-else-if="item.status === 'timeouted'"
                      class="status status--error"
                      >{{ item.status_name }}</span
                    >
                    <span
                      v-else-if="item.status === 'refunded'"
                      class="status status--error"
                      >{{ item.status_name }}</span
                    >
                    <span v-else class="status status--normal"
                      ><span>{{ item.status_name }}</span></span
                    >
                  </td>
                  <td class="right">
                    <v-btn color="primary" type="submit" class="button--small"
                      >Detail</v-btn
                    >
                  </td>
                </router-link>
              </tr>
              <div v-if="props.items.length == 0" class="text-no-results">
                <p>Žádná objednávka nebyla nalezena</p>
              </div>
            </tbody>
          </template>
          <template slot="footer" slot-scope="totals">
            <div
              class="table-footer"
              v-bind:class="{
                'footer--no-results': totals.props.pagination.pageStop === 0,
              }"
            >
              <div class="table-footer__text">
                Počet objednávek na stránce
              </div>
              <div class="table-footer__pages">
                <span v-if="totals.props.pagination.pageStop > 0"
                  ><span class="table-footer__pages-bold"
                    >{{ totals.props.pagination.pageStart + 1 }}-{{
                      totals.props.pagination.pageStop
                    }}</span
                  >
                  z {{ totals.props.pagination.itemsLength }}</span
                >
                <span v-else
                  ><span class="table-footer__pages-bold"
                    >{{ totals.props.pagination.pageStart }}-{{
                      totals.props.pagination.pageStop
                    }}</span
                  >
                  z {{ totals.props.pagination.itemsLength }}</span
                >
              </div>
            </div>
          </template>
        </v-data-table>
      </div>
      <div class="order-items-tab" v-if="itemsAudiobooks.length > 0">
        <h3>
          Seznam Audioknih <span>({{ itemsAudiobooks.length }})</span>
        </h3>
        <v-text-field
          class="input--search control"
          placeholder="Vyhledat"
          outlined
          v-model="searchAudiobooks"
        ></v-text-field>
        <v-data-table
          locale="cs"
          :headers="headersAudiobooks"
          :items="itemsAudiobooks"
          :search="searchAudiobooks"
          :loading="false"
          item-key="name"
          :items-per-page="10"
          :mobile-breakpoint="0"
          class="elevation-1 full-width frankjoy-table"
        >
          <template slot="body" slot-scope="props">
            <tbody>
              <tr v-for="item in props.items" :key="item.id">
                <router-link
                  :to="{ name: 'OrdersDetail', params: { id: item.id } }"
                >
                  <td class="">
                    <div v-if="!item.is_ebook && !item.is_book">Audiokniha</div>
                    <div v-if="item.is_book">Kniha</div>
                    <div v-if="item.is_ebook">E-kniha</div>
                  </td>
                  <td class="">{{ item.id }}</td>
                  <td class="bolder small">{{ item.name }}</td>
                  <td class="bolder small">{{ item.download_app }}</td>
                  <td class="bolder small">{{ item.downloaded }}</td>
                  <td class="right">
                    <v-btn color="primary" type="submit" class="button--small"
                      >Detail</v-btn
                    >
                  </td>
                </router-link>
              </tr>
              <div v-if="props.items.length == 0" class="text-no-results">
                <p>Žádná audiokniha nebyla nalezena</p>
              </div>
            </tbody>
          </template>
          <template slot="footer" slot-scope="totals">
            <div
              class="table-footer"
              v-bind:class="{
                'footer--no-results': totals.props.pagination.pageStop === 0,
              }"
            >
              <div class="table-footer__text">
                Počet audioknih na stránce
              </div>
              <div class="table-footer__pages">
                <span v-if="totals.props.pagination.pageStop > 0"
                  ><span class="table-footer__pages-bold"
                    >{{ totals.props.pagination.pageStart + 1 }}-{{
                      totals.props.pagination.pageStop
                    }}</span
                  >
                  z {{ totals.props.pagination.itemsLength }}</span
                >
                <span v-else
                  ><span class="table-footer__pages-bold"
                    >{{ totals.props.pagination.pageStart }}-{{
                      totals.props.pagination.pageStop
                    }}</span
                  >
                  z {{ totals.props.pagination.itemsLength }}</span
                >
              </div>
            </div>
          </template>
        </v-data-table>
      </div>

      <div class="order-items-tab" v-if="itemsVouchers.length > 0">
        <h3>
          Seznam Voucherů <span>({{ itemsVouchers.length }})</span>
        </h3>
        <v-text-field
          class="input--search control"
          placeholder="Vyhledat"
          outlined
          v-model="searchVouchers"
        ></v-text-field>
        <v-data-table
          locale="cs"
          :headers="headersVouchers"
          :items="itemsVouchers"
          :search="searchVouchers"
          :loading="false"
          item-key="name"
          :items-per-page="10"
          :mobile-breakpoint="0"
          class="elevation-1 full-width frankjoy-table"
        >
          <template slot="body" slot-scope="props">
            <tbody>
              <tr v-for="item in props.items" :key="item.id">
                <router-link
                  :to="{ name: 'VouchersDetail', params: { id: item.id } }"
                >
                  <td class="">{{ item.id }}</td>
                  <td class="bold uppercase">{{ item.code }}</td>
                  <td class="">
                    {{ types.find((type) => type.value === item.type).name }}
                  </td>
                  <td class="smaller" v-html="item.value"></td>
                  <td class="small bold">
                    <span
                      v-if="item.valid === 'yes'"
                      class="status status--success"
                      >K použití</span
                    >
                    <span v-else-if="item.valid === 'no'" class="status"
                      >Použit</span
                    >
                    <span
                      v-else-if="item.valid === 'expired'"
                      class="status status--error"
                      >Expirován</span
                    >
                    <span
                      v-else-if="item.valid === 'not_yet'"
                      class="status status--normal"
                      >Zatím nedostupný</span
                    >
                  </td>
                  <td class="small">{{ formatCreatedAt(item.valid_from) }}</td>
                  <td class="small">{{ formatCreatedAt(item.valid_to) }}</td>
                  <td class="right">
                    <v-btn color="primary" type="submit" class="button--small"
                      >Detail</v-btn
                    >
                  </td>
                </router-link>
              </tr>
              <div v-if="props.items.length == 0" class="text-no-results">
                <p>Žádný poukaz nebyl nalezen</p>
              </div>
            </tbody>
          </template>
          <template slot="footer" slot-scope="totals">
            <div
              class="table-footer"
              v-bind:class="{
                'footer--no-results': totals.props.pagination.pageStop === 0,
              }"
            >
              <div class="table-footer__text">
                Počet poukazů na stránce
              </div>
              <div class="table-footer__pages">
                <span v-if="totals.props.pagination.pageStop > 0"
                  ><span class="table-footer__pages-bold"
                    >{{ totals.props.pagination.pageStart + 1 }}-{{
                      totals.props.pagination.pageStop
                    }}</span
                  >
                  z {{ totals.props.pagination.itemsLength }}</span
                >
                <span v-else
                  ><span class="table-footer__pages-bold"
                    >{{ totals.props.pagination.pageStart }}-{{
                      totals.props.pagination.pageStop
                    }}</span
                  >
                  z {{ totals.props.pagination.itemsLength }}</span
                >
              </div>
            </div>
          </template>
        </v-data-table>
      </div>

      <div class="order-items-tab" v-if="itemsDownloads.length > 0">
        <h3>
          Seznam Podpisů <span>({{ itemsDownloads.length }})</span>
        </h3>
        <v-text-field
          class="input--search control"
          placeholder="Vyhledat"
          outlined
          v-model="searchDownloads"
        ></v-text-field>
        <v-data-table
          locale="cs"
          :headers="headersDownloads"
          :items="itemsDownloads"
          :search="searchDownloads"
          :loading="false"
          item-key="name"
          :items-per-page="10"
          :mobile-breakpoint="0"
          class="elevation-1 full-width frankjoy-table"
        >
          <template slot="body" slot-scope="props">
            <tbody>
              <tr
                v-for="item in props.items"
                :key="item.id"
                @click="openDialogDetail(item.signature)"
              >
                <td class="small">
                  <div v-if="item.is_ebook">E-kniha</div>
                  <div v-if="item.is_book">Kniha</div>
                  <div v-if="!item.is_ebook && !item.is_book">Audiokniha</div>
                </td>
                <td class="small">{{ formatCreatedAt(item.created_at) }}</td>
                <td class="small">{{ formatCreatedAt(item.prepared_at) }}</td>
                <td class="bold">
                  <router-link
                    :to="{
                      name: 'AudiobooksDetail',
                      params: { id: item.audiobook_id },
                    }"
                  >
                    {{ item.audiobook_name }}<br />
                    <span class="small normal"
                      >ID: {{ item.audiobook_id }}</span
                    >
                  </router-link>
                </td>

                <td class="small">
                  <span
                    v-if="item.signature"
                    @click="openDialogDetail(item.signature)"
                  >
                    {{ item.signature.substring(0, 20) }}...
                  </span>
                </td>

                <td class="small bold">
                  <span v-if="item.status === 'ready'" class="status"
                    >{{ item.order }}. {{ item.status_name }}</span
                  >
                  <span
                    v-else-if="item.status === 'failed'"
                    class="status status--error"
                    >{{ item.status_name }}</span
                  >
                  <span
                    v-else-if="item.status === 'deleted'"
                    class="status status--error"
                    >{{ item.status_name }}</span
                  >
                  <span
                    v-else-if="item.status === 'done'"
                    class="status status--success"
                    >{{ item.status_name }}</span
                  >
                  <span
                    v-else-if="item.status === 'missing'"
                    class="status status--error"
                    >{{ item.status_name }}</span
                  >
                  <span
                    v-else-if="item.status === 'preparing'"
                    class="status"
                    >{{ item.status_name }}</span
                  >
                  <span v-else class="status status--normal"
                    ><span>{{ item.status_name }}</span></span
                  >
                </td>
                <td class="right small">
                    <!-- v-if="
                      (item.status === 'deleted' && !item.retried) ||
                        (item.status === 'failed' && !item.retried) ||
                        (item.status === 'missing' && !item.retried)
                    " -->
                  <v-btn
                    color="primary"
                    type="submit"
                    class="button--small"
                    @click.stop="openDialogGenerate(item)"
                    >Generovat znovu</v-btn
                  >
                </td>
              </tr>
              <div v-if="props.items.length == 0" class="text-no-results">
                <p>Žádná generovaná kniha nebyla nalezena</p>
              </div>
            </tbody>
          </template>
          <template slot="footer" slot-scope="totals">
            <div
              class="table-footer"
              v-bind:class="{
                'footer--no-results': totals.props.pagination.pageStop === 0,
              }"
            >
              <div class="table-footer__text">
                Počet generovaných knih na stránce
              </div>
              <div class="table-footer__pages">
                <span v-if="totals.props.pagination.pageStop > 0"
                  ><span class="table-footer__pages-bold"
                    >{{ totals.props.pagination.pageStart + 1 }}-{{
                      totals.props.pagination.pageStop
                    }}</span
                  >
                  z {{ totals.props.pagination.itemsLength }}</span
                >
                <span v-else
                  ><span class="table-footer__pages-bold"
                    >{{ totals.props.pagination.pageStart }}-{{
                      totals.props.pagination.pageStop
                    }}</span
                  >
                  z {{ totals.props.pagination.itemsLength }}</span
                >
              </div>
            </div>
          </template>
        </v-data-table>
      </div>
    </div>

    <v-dialog v-model="dialogDelete" persistent>
      <v-card>
        <v-card-title class="headline">Smazání uživatele</v-card-title>
        <v-card-text>
          Opravdu si přejete smazat uživatele
          <strong>{{ data.forename }} {{ data.surname }}</strong
          >?
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="secondary"
            class="button--dialog"
            @click="closeDialogDelete()"
          >
            zrušit
          </v-btn>
          <v-btn color="error" class="button--dialog" @click="deleteCustomer()">
            smazat
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogEmail" persistent>
      <v-card>
        <v-card-title class="headline">Změna emailu</v-card-title>
        <v-card-text>
          Opravdu si přejete změnit email uživatele
          <strong>{{ data.forename }} {{ data.surname }}</strong
          >?

          <br /><br />
          <v-text-field :error-messages="emailError" outlined v-model="email">
          </v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="secondary"
            class="button--dialog"
            @click="closeDialogEmail()"
          >
            zrušit
          </v-btn>
          <v-btn color="primary" class="button--dialog" @click="changeEmail()">
            Změnit
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogDetail" persistent>
      <v-card>
        <v-card-title class="headline">Celý podpis</v-card-title>
        <v-card-text>
          <span v-if="currentSignature"> {{ currentSignature }}</span>
          <span v-else>Audiokniha ještě nebyla vygenerovaná!</span>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="empty"
            class="button--dialog"
            @click="closeDialogDetail()"
          >
            zavřít
          </v-btn>

          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogPassword" persistent>
      <v-card>
        <v-card-title class="headline">Změna emailu</v-card-title>
        <v-card-text>
          Opravdu si přejete odeslat email pro změnu hesla uživateli
          <strong>{{ data.forename }} {{ data.surname }}</strong
          >?<br />
          Email pro doručení: {{ data.email }}
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="secondary"
            class="button--dialog"
            @click="closeDialogForgot()"
          >
            zrušit
          </v-btn>
          <v-btn
            color="primary"
            class="button--dialog"
            @click="changePassword()"
          >
            odeslat
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogPasswordConfirm" persistent>
      <v-card>
        <v-card-title class="headline">Změna hesla</v-card-title>
        <v-card-text>
          Úspěšně jste odeslali email pro změnu hesla.
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="empty"
            class="button--dialog"
            @click="closeDialogForgotConfirm()"
          >
            zavřít
          </v-btn>

          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogGenerate" persistent>
      <v-card>
        <v-card-title class="headline">Generovat znovu</v-card-title>
        <v-card-text>
          Opravdu chcete znovu vygenerovat knihu<br /><strong>{{
            currentBook
          }}</strong>
          uživateli <strong>{{ currentName }}</strong
          >? <br /><br />
          <span class="status status--error" v-if="bookAlreadyRemade"
            >Nová kopie audioknihy je už pro uživatele připravena nebo se právě
            připravuje.</span
          >
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="empty"
            class="button--dialog"
            @click="closeDialogGenerate()"
          >
            zavřít
          </v-btn>
            <!-- v-if="!bookAlreadyRemade" -->
          <v-btn
            color="primary"
            class="button--dialog"
            @click="generateNew()"
          >
            generovat
          </v-btn>

          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";
import moment from "moment";
export default {
  name: "CustomersDetail",
  components: {},

  data() {
    return {
      loading: false,
      mergeAccountDialog: false,
      bookAlreadyRemade: true,
      dialogDetail: false,
      dialogGenerate: false,
      currentBook: "",
      currentName: "",
      currentId: "",
      currentSignature: "",

      dialogPassword: false,

      dialogPasswordConfirm: false,
      emailError: "",
      email: null,
      dialogEmail: false,
      dialogDelete: false,
      loaded: false,
      searchAudiobooks: "",
      searchDownloads: "",
      searchVouchers: "",
      searchOrders: "",
      data: {},
      itemsOrders: [],
      searchAccount: "",
      foundAccounts: [],
      selectedAccount: null,
      confirmMerging: false,
      loadingAccounts: false,
      merging: false,
      snackbar: false,
      snackText: null,
      snackColor: "success",
      headersOrders: [
        //  { text: '', value: '',  align: 'left',sortable: false },
        { text: "ID", value: "id", align: "left" },
        { text: "Číslo objednávky", value: "number", align: "left" },
        { text: "Vytvořeno", value: "created_at", align: "left" },
        { text: "Cena", value: "price", align: "left" },
        { text: "Stav", value: "status_name", align: "left" },
        { text: "", value: "controls", align: "right" },
      ],
      itemsAudiobooks: [],
      headersAudiobooks: [
        //  { text: '', value: '',  align: 'left',sortable: false },
        { text: "Typ", value: "type", align: "left", sortable: false },
        { text: "ID", value: "id", align: "left" },
        { text: "Název", value: "name", align: "left" },
        { text: "Staženo v app", value: "download_app", align: "left" },
        { text: "Staženo web", value: "downloaded", align: "left" },
        { text: "", value: "controls", align: "right" },
      ],

      headersVouchers: [
        //  { text: '', value: '',  align: 'left',sortable: false },
        { text: "ID", value: "id", align: "left" },
        { text: "Kód", value: "code", align: "left" },
        { text: "Typ", value: "type", align: "left" },
        { text: "Hodnota", value: "value", align: "left" },
        { text: "Stav", value: "valid_text", align: "left" },
        { text: "Platnost od", value: "valid_from", align: "left" },
        { text: "Platnost do", value: "valid_to", align: "left" },
        { text: "", value: "controls", align: "right" },
      ],
      itemsVouchers: [],
      types: [
        { value: "audiobook", name: "Audiokniha" },
        { value: "audiobook_percentage", name: "Sleva na audioknihu" },
        { value: "category_percentage", name: "Sleva na kategorii" },
        { value: "audiobook_crowns", name: "Sleva na audioknihu" },
        { value: "percentage", name: "Sleva na nákup" },
        { value: "crowns", name: "Sleva na nákup" },
      ],
      itemsDownloads: [],
      headersDownloads: [
        //  { text: '', value: '',  align: 'left',sortable: false },
        { text: "Typ", value: "type", align: "left", sortable: false },
        { text: "Zahájení generování", value: "created_at", align: "left" },
        { text: "Vygenerováno", value: "prepared_at", align: "left" },
        { text: "Kniha", value: "audiobook_name", align: "left" },
        { text: "Podpis", value: "signature", align: "left" },
        // { text: "Staženo", value: "downloaded", align: "left" },
        // { text: "Staženo v app", value: "downladed_app", align: "left" },
        { text: "Stav", value: "status_name", align: "left" },
        { text: "", value: "", align: "left", sortable: false },
      ],
    };
  },

  created() {
    this.fetchData();
  },
  computed: {
    ...mapState(["profile"]),
  },
  mounted() {},
  methods: {
    async mergeAccount() {
      try {
        this.merging = true;

        await this.$axios.post("/merge-account", {
          source_id: this.selectedAccount.id,
          target_id: Number(this.$route.params.id),
        });
        this.merging = false;
        this.selectedAccount = null;
        this.mergeAccountDialog = false;
        this.foundAccounts = [];
        this.confirmMerging = false;
        this.snackText = "Audioknihy byly převedeny.";
        this.snackbar = true;
      } catch (error) {
        console.error(error);
        if (error.response) {
          this.snackText = error.response.data.error.description;
          this.snackColor = "error";
          this.snackbar = true;
          this.merging = false;
        }
      }
    },
    handleSelectAccount(account) {
      this.selectedAccount = account;
      this.foundAccounts = [];
      this.searchAccount = "";
    },
    async handleSearchAccount() {
      try {
        this.loadingAccounts = true;
        const { data } = await this.$axios.get(
          "/merge-account/" + this.searchAccount
        );
        this.foundAccounts = data.data;
        this.loadingAccounts = false;
      } catch (error) {
        this.loadingAccounts = false;
        console.error(error);
      }
    },
    async openMergeDialog() {
      try {
        this.loading = true;
        this.loading = false;
        this.mergeAccountDialog = true;
      } catch (error) {
        console.error(error);
      }
    },
    closeDialogEmail() {
      this.dialogEmail = false;
    },
    openDialogEmail() {
      this.dialogEmail = true;
    },

    openDialogForgot() {
      this.dialogPassword = true;
    },
    closeDialogForgot() {
      this.dialogPassword = false;
    },
    openDialogForgotConfirm() {
      this.dialogPasswordConfirm = true;
    },
    closeDialogForgotConfirm() {
      this.dialogPasswordConfirm = false;
    },
    sendResetPassword() {},
    closeDialogDelete() {
      this.dialogDelete = false;
    },
    openDialogDelete() {
      this.dialogDelete = true;
    },
    formatCreatedAt(date) {
      if (date) {
        return moment.unix(date).format("D.M.YYYY - HH:mm");
      } else {
        return null;
      }
    },
    formatLastLog(date) {
      if (date) {
        return moment.unix(date).format("D.M.YYYY - HH:mm");
      } else {
        return "nikdy nepřihlášen";
      }
    },
    changePassword() {
      this.dialogPassword = false;
      this.loaded = false;
      const request = {
        email: this.data.email,
      };
      this.$axios
        .post("/password/forgot", request)
        .then((response) => {
          this.loaded = true;
          this.dialogPasswordConfirm = true;
        })
        .catch((e) => {
          this.loaded = true;
        });
    },
    deleteCustomer() {
      this.dialogDelete = false;
      this.loaded = false;
      const request = this.data;
      this.$axios
        .delete("/admin/users/" + this.$route.params.id + "/delete", request)
        .then((response) => {
          this.$router.push({ name: "Customers" });
        })
        .catch((e) => {
          this.loaded = true;
        });
    },
    changeEmail() {
      this.dialogEmail = false;
      this.loaded = false;
      const request = {
        email: this.email,
      };
      this.$axios
        .put("/admin/users/" + this.$route.params.id + "/email", request)
        .then((response) => {
          this.fetchData();
          //this.$router.push({name: 'Customers'});
        })
        .catch((e) => {
          this.dialogEmail = true;
          if ((e.response.data.status = "email_exists")) {
            this.emailError = "Zadaný email je již používán";
          } else {
            this.emailError = "Neznámá chyba";
          }

          this.loaded = true;
        });
    },

    closeDialogDetail() {
      this.dialogDetail = false;
    },
    openDialogDetail(signature) {
      this.currentSignature = signature;
      this.dialogDetail = true;
    },
    closeDialogGenerate() {
      this.dialogGenerate = false;
    },
    openDialogGenerate(item) {
      this.$axios
        .get("/admin/audiobooks/downloads/check/" + item.id)
        .then((response) => {
          this.currentBook = item.audiobook_name;
          this.currentName = item.user_name;
          this.currentId = item.id;
          this.dialogGenerate = true;
          this.bookAlreadyRemade = response.data.retried;

          if (response.data.retried) {
            this.fetchData();
          }
        })
        .catch((e) => {
          this.currentBook = item.audiobook_name;
          this.currentName = item.user_name;
          this.currentId = item.id;
          this.bookAlreadyRemade = true;
          this.dialogGenerate = true;
        });
    },
    generateNew() {
      this.$axios
        .post("/admin/audiobooks/downloads/new/" + this.currentId)
        .then((response) => {
          this.fetchData();
          this.dialogGenerate = false;
        })
        .catch((e) => {
          this.dialogGenerate = false;
        });
    },

    editUser() {
      this.loaded = false;
      const request = this.data;
      this.$axios
        .put("/admin/users/" + this.$route.params.id + "/edit", request)
        .then((response) => {
          this.$router.push({ name: "Customers" });
        })
        .catch((e) => {
          this.errors = e.response.data.error_inputs;
          this.loaded = true;
        });
    },

    fetchData() {
      this.$axios
        .get("/admin/users/" + this.$route.params.id)
        .then((response) => {
          this.data = response.data.user;
          this.email = response.data.user.email;
          response.data.items_orders.forEach((item) => {
            if (item.status === "created") {
              item.status_name = "Vytvořena";
            } else if (item.status === "canceled") {
              item.status_name = "Zrušena";
            } else if (item.status === "storned") {
              item.status_name = "Stornována";
            } else if (item.status === "paid") {
              item.status_name = "Zaplacena";
            } else if (item.status === "timeouted") {
              item.status_name = "Vypršela";
            } else if (item.status === "refunded") {
              item.status_name = "Platba vrácena";
            } else {
              if (item.status) {
                item.status_name = "Neznámý - " + item.status;
              } else {
                item.status_name = "Neznámý";
              }
            }
          });

          response.data.vouchers.forEach((item) => {
            if (item.valid == "yes") {
              item.valid_text = "K použití";
            } else if (item.valid == "no") {
              item.valid_text = "Použit";
            } else if (item.valid == "expired") {
              item.valid_text = "Expirován";
            } else if (item.valid == "not_yet") {
              item.valid_text = "Zatím nedostupný";
            }

            if (item.valid_from && item.valid_to) {
              item.valid_date_text =
                "od: " +
                this.formatCreatedAt(item.valid_from) +
                " | do: " +
                this.formatCreatedAt(item.valid_to);
            } else if (item.valid_from) {
              item.valid_date_text =
                "od: " + this.formatCreatedAt(item.valid_from);
            } else if (item.valid_to) {
              item.valid_date_text =
                "do: " + this.formatCreatedAt(item.valid_to);
            } else {
              item.valid_date_text = "";
            }
          });

          response.data.downloads.forEach((item) => {
            if (item.status === "missing") {
              item.status_name = "Neexistuje";
            } else if (item.status === "deleted") {
              item.status_name = "Smazáno";
            } else if (item.status === "failed") {
              item.status_name = "Chybně vygenerováno";
            } else if (item.status === "ready") {
              item.status_name = "V pořadí";
            } else if (item.status === "preparing") {
              item.status_name = "Připravuje se";
            } else if (item.status === "done") {
              item.status_name = "Připraveno";
            } else {
              if (item.status) {
                item.status_name = "Neznámý - " + item.status;
              } else {
                item.status_name = "Neznámý";
              }
            }
          });

          this.itemsDownloads = response.data.downloads;
          this.itemsVouchers = response.data.vouchers;
          this.itemsOrders = response.data.items_orders;
          this.itemsAudiobooks = response.data.items_audiobooks;
          this.loaded = true;
        })
        .catch((e) => {
          this.loaded = true;
          this.$router.push({ name: "Customers" });
        });
    },
  },
  watch: {
    email() {
      this.emailError = "";
    },
  },
};
</script>

<style lang="scss"></style>
